import classNames from 'classnames';
import { Line, LineType } from '../types';

export const LineView = ({ line, onClick }: { line: Line, onClick: () => void }) => {
  const [content, lineType] = line;

  const classes = classNames(
    'cursor-default',
    {
    'text-neutral-500': lineType === LineType.MINOR.valueOf()
    }
  );

  return (
    <p
      className={classes}
      onClick={onClick}
    >
      {
        line[2] && <sup>{line[2]}</sup>
      }
      { content }
    </p>
  );
};
